import React, { useState } from 'react'

const HELP_CONTENT = {
  architecte: [
    {
      id: 'creer',
      label: 'Creer un chantier',
      texte: 'Dans "Mes chantiers", cliquez sur "+ Nouveau chantier". Remplissez le nom, l\'adresse et invitez vos entreprises par email. Un code a 6 caracteres est genere automatiquement.',
    },
    {
      id: 'inviter',
      label: 'Inviter des entreprises',
      texte: 'Lors de la creation du chantier, entrez les emails des entreprises. Si elles ont un compte, elles recevront une notification. Sinon, un lien email pre-rempli avec le code vous est propose.',
    },
    {
      id: 'code',
      label: 'Partager le code client',
      texte: 'Dans la fiche chantier, copiez le code a 6 caracteres affiches sous le nom. Envoyez-le a votre client : il pourra suivre l\'avancement sans creer de compte.',
    },
    {
      id: 'tache',
      label: 'Valider une tache',
      texte: 'Dans l\'onglet "Taches", les taches marquees "Termine" par les entreprises apparaissent pour validation. Cliquez "Valider" pour les marquer comme validees.',
    },
    {
      id: 'messages',
      label: 'Messagerie interne / client',
      texte: 'L\'onglet "Messages" propose deux canaux : discussion interne (avec vos entreprises) et message client (avec le proprietaire du chantier).',
    },
  ],
  entreprise: [
    {
      id: 'rejoindre',
      label: 'Rejoindre un chantier',
      texte: 'Sur le tableau de bord, entrez le code a 6 caracteres fourni par votre architecte dans la zone "Rejoindre un chantier". Vous accedeez immediatement au chantier.',
    },
    {
      id: 'tache',
      label: 'Mettre a jour une tache',
      texte: 'Dans "Mes taches", vous pouvez changer le statut de chaque tache : En attente, En cours, ou Termine. L\'architecte sera notifie quand vous marquez une tache comme terminee.',
    },
    {
      id: 'photo',
      label: 'Uploader une photo',
      texte: 'Dans "Photos chantier", glissez-deposez vos photos ou cliquez sur la zone d\'upload. Les photos sont visibles par l\'architecte et les autres membres du chantier.',
    },
    {
      id: 'notifications',
      label: 'Voir mes notifications',
      texte: 'Le badge rouge sur "Notifications" indique de nouveaux messages ou ajouts. Cliquez pour les lire et les marquer comme vus.',
    },
  ],
  client: [
    {
      id: 'avancement',
      label: 'Consulter l\'avancement',
      texte: 'L\'onglet "Avancement" affiche la progression globale du chantier et le detail de chaque tache avec leur statut actuel.',
    },
    {
      id: 'documents',
      label: 'Lire les documents',
      texte: 'L\'onglet "Documents" liste tous les fichiers partages par votre architecte. Cliquez sur un document pour le telecharger.',
    },
    {
      id: 'messages',
      label: 'Envoyer un message',
      texte: 'L\'onglet "Messages" ouvre un canal direct avec votre architecte. Ecrivez votre message et appuyez sur Envoyer. L\'architecte vous repondra depuis son tableau de bord.',
    },
    {
      id: 'code',
      label: 'Changer de chantier',
      texte: 'Cliquez sur "Changer de chantier" en haut a droite pour entrer un autre code et acceder a un autre suivi.',
    },
  ],
}

export default function HelpWidget({ role, onRelancerTutoriel }) {
  const [ouvert, setOuvert] = useState(false)
  const [itemActif, setItemActif] = useState(null)

  const items = HELP_CONTENT[role] || HELP_CONTENT.client

  const toggleItem = (id) => {
    setItemActif(prev => prev === id ? null : id)
  }

  return (
    <>
      {/* Panneau d'aide */}
      {ouvert && (
        <div style={{
          position: 'fixed', bottom: 90, right: 24, width: 320, zIndex: 9990,
          background: 'white', borderRadius: 16, boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
          border: '1px solid #e2e8f0', overflow: 'hidden',
          animation: 'fadeSlideUp 0.2s ease',
        }}>
          {/* Header */}
          <div style={{ background: '#1D9E75', padding: '16px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ color: 'white', fontWeight: 700, fontSize: 15 }}>Centre d\'aide</div>
              <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 12, marginTop: 2 }}>
                {role === 'architecte' ? 'Guide architecte' : role === 'entreprise' ? 'Guide entreprise' : 'Guide client'}
              </div>
            </div>
            <button onClick={() => setOuvert(false)} style={{
              background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 8,
              color: 'white', cursor: 'pointer', padding: '4px 8px', fontSize: 14,
            }}>x</button>
          </div>

          {/* Items */}
          <div style={{ maxHeight: 360, overflowY: 'auto' }}>
            {items.map(item => (
              <div key={item.id}>
                <button
                  onClick={() => toggleItem(item.id)}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    width: '100%', padding: '13px 18px', border: 'none', background: 'white',
                    cursor: 'pointer', borderBottom: '1px solid #f5f6fa', textAlign: 'left',
                    transition: 'background 0.1s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f8fffe'}
                  onMouseLeave={e => e.currentTarget.style.background = 'white'}
                >
                  <span style={{ fontSize: 13, fontWeight: 500, color: '#2d3748' }}>{item.label}</span>
                  <span style={{ fontSize: 12, color: '#a0aec0', marginLeft: 8, flexShrink: 0 }}>
                    {itemActif === item.id ? '▲' : '▼'}
                  </span>
                </button>
                {itemActif === item.id && (
                  <div style={{
                    padding: '10px 18px 14px', background: '#f8fffe',
                    borderBottom: '1px solid #e2e8f0',
                    fontSize: 13, color: '#4a5568', lineHeight: 1.6,
                    borderLeft: '3px solid #1D9E75',
                  }}>
                    {item.texte}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Footer */}
          {onRelancerTutoriel && (
            <div style={{ padding: '12px 18px', borderTop: '1px solid #e2e8f0', background: '#fafafa' }}>
              <button
                onClick={() => { onRelancerTutoriel(); setOuvert(false) }}
                style={{
                  width: '100%', padding: '9px 0', background: '#e8f7f2',
                  border: '1.5px solid #c6f6d5', borderRadius: 8, color: '#1D9E75',
                  fontSize: 13, fontWeight: 600, cursor: 'pointer',
                }}
              >
                Relancer le tutoriel
              </button>
            </div>
          )}
        </div>
      )}

      {/* Bouton flottant */}
      <button
        id="step-help-widget"
        onClick={() => setOuvert(o => !o)}
        title="Aide"
        style={{
          position: 'fixed', bottom: 24, right: 24, zIndex: 9991,
          width: 52, height: 52, borderRadius: '50%',
          background: ouvert ? '#158a60' : '#1D9E75',
          border: 'none', color: 'white', fontSize: 22, fontWeight: 700,
          cursor: 'pointer', boxShadow: '0 4px 16px rgba(29,158,117,0.45)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'all 0.2s',
        }}
        onMouseEnter={e => { if (!ouvert) e.currentTarget.style.transform = 'scale(1.1)' }}
        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
      >
        ?
      </button>

      <style>{`
        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  )
}
